import {jwtDecode} from "jwt-decode";

const getStoredUserInfo = () => {
  try {
    const token = localStorage.getItem("iris-accessToken");
    if (!token) return null;
    const decoded = jwtDecode<{id: number; email: string}>(token);
    return {
      token,
      user: decoded,
    };
  } catch (error) {
    console.error("Error decoding token", error);
    return null;
  }
};

export default getStoredUserInfo;
